import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { setGlobalVariable } from '../shared';

const Codes = ({ codesModule, languageList, activeTab, baseUrl }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const downArrow = require("../icons/downarrow.png");

  const [intValue, setIntValue] = useState(null);

  //Down arrow
  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content");
    if (!scrollContainer) return;

    const handleScroll = () => {
      const bottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;
      setShowScrollIndicator(!bottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(handleScroll);
    });

    resizeObserver.observe(scrollContainer);

    requestAnimationFrame(handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
    if (token != null) {
      axios
        .get(baseUrl + `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`, { headers })
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log('Fetched intValue:', fetchedValue);
        })
        .catch((error) => {
          console.error('Error fetching intValue:', error);
        });
    }
  }, []);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setSelectedLanguage(value);  // Update selected language
  };

  if (!codesModule[0]) {
    return <div>No student data available</div>;
  }

  const student = codesModule[0];

  const subjects = [
    "ALL", "ELAR", "RE", "WR", "MA", "SC", "SS"
  ];

  const subjectsDisplay = [
    "ALL", "ELAR", "Reading", "Writing", "Math", "Science", "SStudies"
  ];

  const fields = ["TTS", "Auto TTS", "Speech To Text", "Content Language Supports", "Spelling Support", "Calculator", "Medical Exemption", "No Authentic Academic Response", "HideTimer", "WordPrediction"];
  const fields_ = ["speech", "AutoTTS", "SpeechToText", "contentSupport", "spellingAssistance", "basicCalculator", "ME", "NAAR", "HideTimer", "WordPrediction"];

  // Convert the language list to the correct format
  const getLanguageList = languageList.reduce((acc, lang) => {
    acc.push({ value: lang.Value, display: lang.Display });
    return acc;
  }, []);

  return (<>

    <div id="StudentSupport" className="panelitem isotopeitem ui-widget ui-corner-all">
      <header className="ui-widget-header supportsHeader">Student Support</header>
      <content>
        <input type="hidden" id="Studentkey" name="Studentkey" value={student.dbKey || ""} />
        <input type="hidden" id="schoolYear" name="schoolYear" value={student.schoolYear} />
        <input type="hidden" id="gradelevel" name="gradelevel" value={student.gradeLevel || ""} />

        <table id="supportstbl" style={{ width: "100%" }}>
          <thead style={{ background: "#e2eed4", fontWeight: "bold" }}>
            <tr>
              <td style={{ width: "5%" }}>Subject</td>
              {fields.map((field) => (
                <td key={field} style={{ width: "10%", textAlign: "center" }}>
                  {field.replace(/([A-Z])/g, " $1").trim()}
                </td>
              ))}
              <td style={{ width: "10%", textAlign: "center" }}>Bilingual Dictionary</td>
            </tr>
          </thead>
          <tbody>
            {subjects.map((subject, index) => {
              return (
                <tr key={subject} style={{ background: index % 2 === 0 ? "#e2eed4" : "#ffffff" }}>
                  <td>{subjectsDisplay[index]}</td>

                  {fields_.map((field) => {
                    const isAllCheckedForField =
                      field === "basicCalculator"
                        ? ["MA", "SC"].every((sub) => student[`${field}_${sub}`] === "Yes")
                        : subjects.filter((sub) => sub !== "ALL").every((sub) => student[`${field}_${sub}`] === "Yes");

                    const isFieldChecked =
                      subject === "ALL"
                        ? isAllCheckedForField
                        : student[`${field}_${subject}`] === "Yes";

                    if (field === "basicCalculator" && ["ALL", "MA", "SC"].includes(subject)) {
                      return (
                        <td key={field} style={{ width: "4%", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            id={`${subject}${field}`}
                            name={`${subject}${field}`}
                            checked={isFieldChecked}
                            onChange={handleCheckboxChange}
                          />
                        </td>
                      );
                    }

                    if (field !== "basicCalculator") {
                      return (
                        <td key={field} style={{ width: "4%", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            id={`${subject}${field}`}
                            name={`${subject}${field}`}
                            checked={isFieldChecked}
                            onChange={handleCheckboxChange}
                          />
                        </td>
                      );
                    }

                    return <td key={field}></td>;
                  })}

                  <td>
                    <div className="custom-select-wrapper">
                      <select
                        id={`${subject}BD`}
                        name={`${subject}BD`}
                        style={{ width: "120px" }}
                        value={student[`Dictionary_${subject}_Value`] || 0}
                        onChange={handleSelectChange}
                        className="custom-select"
                      >
                        {getLanguageList.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.display}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </content>
    </div>

    {showScrollIndicator && (
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "#d0cfcf99",
          color: "white",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "22px",
          zIndex: 9999,
          cursor: "pointer",
          animation: "bounce 1.5s infinite",
        }}
        onClick={() =>
          window.scrollBy({ top: 200, behavior: "smooth" })
        }
      >
        <img
          src={downArrow}
          alt="Scroll down"
          style={{ width: "22px", height: "22px" }}
        />
      </div>
    )}

  </>
  );
};

export default Codes;